<template>
  <transition name="slide-fade">
    <div id="cookies" v-if="!accepted">
      <div class="container">
        <b-row>
          <b-col>
            <div class="d-flex">
              <img
                src="@/assets/images/logoprosegurBlanco.svg"
                class="mr-3 mb-auto"
                alt="Prosegur Cash"
                width="30"
              />
              <div>
                <i18n path="global.cookiesPolicy.text" tag="p">
                  <template #url>
                    <a :href="sanitizedUrl" target="_blank" rel="noopener">
                      {{ $t("global.cookiesPolicy.linkText") }}
                    </a>
                  </template>
                </i18n>
                <p-button id="acceptCookies" variant="transparent" @click="acceptCookies">
                  {{ $t("action.acceptCookies") }}
                </p-button>
              </div>
            </div>
          </b-col>
        </b-row>
      </div>
    </div>
  </transition>
</template>

<script lang="ts">
import { Vue, Component } from "vue-property-decorator";
import { PButton } from "@/components/look";
import { sanitizeUrl } from "@braintree/sanitize-url";

@Component({
  components: { PButton },
})
export default class CookieBanner extends Vue {
  accepted: boolean = localStorage.getItem("acceptCookies") === "true";
  acceptCookies(): void {
    localStorage.setItem("acceptCookies", "true");
    this.accepted = true;
  }

  get sanitizedUrl(): string {
    return sanitizeUrl(this.$t("global.cookiesPolicy.link"));
  }
}
</script>

<style scoped lang="scss">
#cookies {
  position: fixed;
  background-color: #211f1f;
  bottom: 0;
  left: 0;
  right: 0;
  color: white;
  padding: 1rem 0;
  z-index: 999;
}

#acceptCookies {
  padding: 6px 20px;

  &::v-deep .textButton {
    font-size: 1rem;
    font-weight: normal;
  }
}

.slide-fade-enter-active {
  transition: all 0.3s ease;
}

.slide-fade-leave-active {
  transition: all 0.5s ease;
}

.slide-fade-enter,
.slide-fade-leave-to {
  transform: translateY(200px);
  opacity: 0;
}
</style>
